<template>
  <table :class="$style[classes]">
    <base-item-form v-for="(item,index) in fieldsArr" @dateSubmit="dateSubmit" :key="index" :filed="item" v-model="formValue[item.key]"
    ref="basicItem" :class="$style['sign-form-base']" :isEdit="isEdit"
    :addressBusinessType="addressBusinessType" :isCuderRadioClasses="isCuderRadioClasses"
    :isSpecalActiveSign="isSpecalActiveSign" :isAnniversarySign="isAnniversarySign"></base-item-form>
  </table>
</template>

<script>
import formMixins from 'mixins/form'
import baseItemForm from 'cps/base/base-item-form'
// 组件class前缀
const prefixCls = 'pt-sign-notes-form'

export default {
  name: 'pt-sign-notes-form',
  mixins: [formMixins],
  components: {
    baseItemForm
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // 单选特殊样式（使用cude的样式）【问卷调查的情况】
    isCuderRadioClasses () {
      return this.type === 'QUESTIONNAIRE'
    },
    basicItem () {
      return this.$refs.basicItem
    }
  },
  props: {
    // 过滤省市区接口所需type
    addressBusinessType: {
      type: String
    },
    fieldsArr: {
      type: Array
    },
    type: {
      type: String
    },
    isSpecalActiveSign: {
      type: Boolean
    },
    isAnniversarySign: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean
    },
    noteDetail: {
      type: Object
    }
  },
  data () {
    return {
      formValue: {

      },
      visitTimeList: {}
    }
  },
  watch: {
    noteDetail: {
      handler: function (val) {
        if (val.genericFormData && val.genericFormData.data) {
          this.formValue = { ...val.genericFormData.data, ...this.formValue }
        }
      },
      immediate: true
    },
    fieldsArr: {
      handler: function (val) {
        val.forEach(item => {
          if (item.key === 'parseDate' && this.isSpecalActiveSign) {
            item.startDate = new Date().getTime() + 3 * 60 * 60 * 24 * 1000
          }
        })
      }
    },
    'formValue.address': {
      handler: function (val) {
        if (this.isAnniversarySign) {
          if (val && val.provinceName && val.cityGbCode) {
            this.getBranchVenuesInfo(val.provinceName, val.cityGbCode)
          } else if (val && val.provinceName) {
            this.fieldsArr.forEach(item => {
              if (item.optionsEnum === 'lifeExperienceHallVisit') {
                item.options = []
                this.formValue.experienceHall = undefined
              }
              if (item.optionsEnum === 'lifeExperienceHallVisitTime') {
                item.options = []
                this.formValue.parseDate = undefined
              }
            })
          }
        }
      },
      deep: true,
      immediate: true
    },
    'formValue.experienceHall': {
      handler: function (val) {
        if (val && val.id) {
          this.visitTimeList.hallInfoList && this.visitTimeList.hallInfoList.forEach(item => {
            if (item.lifeExperienceHallDTO.id === val.id) {
              this.fieldsArr.forEach(sItem => {
                if (sItem.optionsEnum === 'lifeExperienceHallVisitTime') {
                  sItem.options = item.visitTime
                  if (!sItem.options.some(tItem => tItem.value === this.formValue.parseDate)) {
                    this.formValue.parseDate = undefined
                  }
                }
              })
            }
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    emptyDate (key) {
      this.$refs.basicItem.forEach(item => {
        if (item.key === key) {
          item.emptyDate(key)
        }
      })
    },
    dateSubmit (val, filedKey) {
      this.$emit('dateSubmit', val, filedKey)
    },
    // 请求分子公司的场馆信息
    getBranchVenuesInfo (val, cityGbCode) {
      let data = {
        activityKey: 'TWENTIETH_ANNIVERSARY_ACT',
        province: val,
        cityGbCode
      }
      this.$store.dispatch('getBranchVenuesInfo', data).then(res => {
        this.visitTimeList = res
        this.fieldsArr.forEach(item => {
          if (item.optionsEnum === 'lifeExperienceHallVisit') {
            item.options = []
            if (res.experienceHallList) {
              item.options = res.experienceHallList
            }
          }
        })
        this.formValue.experienceHall = { id: res.experienceHallList.length && res.experienceHallList[0].value, name: res.experienceHallList.length && res.experienceHallList[0].label }
        this.formValue.organizationName = res.organizationName
        this.formValue.organizationId = res.organizationId
      }).catch(err => {
        this.$message.error(err || '获取活动场地失败')
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-sign-notes-form{
  max-width: 500px;
  :global{
    .wt-selector{
      width: 100%
    }
  }
}
</style>
